<div class="surgical-diagnosis-container">
    <app-tdo-progress-spinner class="spinner" style="flex: 1;" *ngIf="isLoading"></app-tdo-progress-spinner>
    <div *ngIf="!isLoading" class="section" style="display: flex; flex-direction: row; height: 100%; max-height: 100%;    overflow-y: hidden;">
        <div class="left-panel">
            <div class="section-header" style="flex-basis: 30px; min-width: 650px;">
                <div class="section-header-title">
                  Tooth: {{toothName}}
                </div>
              </div>
        <div class="section" style="min-width: 650px;">
            <div class="row" style="display: flex; flex-direction: row; align-items: center; padding: 5px 0 5px 10px;">
                <div class="label" style="white-space: nowrap; margin-right: 8px; max-width: 120px;">Completed date:</div>
                <input
                  style="background-color: white; padding-left: 12px; border-radius: 6px; border: 1px solid rgba(0, 0, 0, 0.05); outline: 0; height: 36px; width: 120px; margin-bottom: 1px;"
                  (focus)="onCompleteDateFocus($event)"
                  (blur)="onCompleteDateInputFinish($event.target.value)"
                  [value]="completedDateFormatted"
                  autocomplete="off"
                />
                <div class="top-left-row-label">Asistent:</div>
                <div style="width: 15%; margin-right: 8px;">
                  <tdo-dropdown-v2 [datasource]="assistants" [value]="getAssistant()" [displayPredicate]="assistantPredicate"
                    (selectionChange)="onAssistantChange($event)"></tdo-dropdown-v2>
                </div>
                <div class="top-left-row-label">Surgery Type:</div>
                <div class="t-dropdown" style="width: 15%;">
                    <app-tdo-enum-select
                      name="enumSurgeryType"
                      [validValueItemId]="currentDiagnosis.enumSurgeryTypeId"
                      (enumSelected)="currentDiagnosis.enumSurgeryTypeId = $event.ValidValueItemId"
                      displayProperty="ItemDisplayValue">
                    </app-tdo-enum-select>
                </div>
            </div>
            <div class="probings-section">
            <div class="probings" style="padding-left: 10px;">
                <div>Probings</div>
                <div *ngFor="let p of mtiProbings">
                  <input type="number" min="0" max="10" [value]="p.ItemDisplayValue" readonly style="width: 48px; margin-right: 6px; text-align: center; background: #f9f9f9; border-radius: 4px; border: 1px solid #e0e0e0;" />
                  <span style="padding-left: 5px;">{{p.ItemSValue}}</span>
                </div>
            </div>
            <div class="roots-involved">
                <div>Roots Involved</div>
                <div *ngFor="let r of ['MB','D','DB','B','S','L','Furca']">
                  <mat-checkbox class="checkbox" style="flex: 1;" [checked]="currentDiagnosis['isRoot_' + r]" (change)="onBooleanChange($event, 'isRoot_' + r)">{{r}}</mat-checkbox>
                </div>
            </div>
            
            <div class="first-retreat">
              <mat-checkbox class="checkbox" style="flex: 1;" [checked]="currentDiagnosis.isRetreatment" (change)="onBooleanChange($event, 'isRetreatment')">First Retreatment:</mat-checkbox>
            </div>
        </div>
            <div class="flap-diagram">
            <div class="flap-header">Quad with Flap Diagram</div>
            <div class="flap-image">
                <span>Click to paste image</span>
            </div>
            </div>
        </div>
        <div class="treatment-history section" style="min-width: 650px;">
            <div class="header">Treatment History</div>
            <div class="history-row">
            <span>?</span>
            <input type="text" placeholder="Date" />
            <input type="text" placeholder="Doctor" />
            <input type="text" placeholder="Type" />
            <input type="checkbox" id="sve" />
            <label for="sve">SVE</label>
            </div>
        </div>
        </div>
        <div class="right-panel">
            <div class="section-header" style="flex-basis: 30px;">
              </div>
        <div class="section">
            <div class="row" style="padding-top: 10px;">
            <span class="label" style="padding-left: 20px; width: auto;">Pre-Op Prognosis:</span>
            <div class="t-dropdown" style="width: 160px;">
                <app-tdo-enum-select
                  name="enumSurgeryPreOpPrognosis"
                  [validValueItemId]="currentDiagnosis.enumSurgeryPreOpPrognosisId"
                  (enumSelected)="currentDiagnosis.enumSurgeryPreOpPrognosisId = $event.ValidValueItemId"
                  displayProperty="ItemDisplayValue">
                </app-tdo-enum-select>
            </div>
            </div>
            <div class="columns">
            <div class="column" style="padding-left: 10px;">
                <div class="header">Anatomical Considerations</div>
                <div *ngFor="let item of anatomicalConsiderations">
                  <mat-checkbox class="checkbox" style="flex: 1;" [checked]="currentDiagnosis[item.value]" (change)="onBooleanChange($event, item.value)">{{item.description}}</mat-checkbox>
                </div>
            </div>
            <div class="column">
                <div class="header">Treatment Complexities</div>
                <div *ngFor="let item of treatmentComplexities">
                  <mat-checkbox class="checkbox" style="flex: 1;" [checked]="currentDiagnosis[item.value]" (change)="onBooleanChange($event, item.value)">{{item.description}}</mat-checkbox>
                </div>
                <div class="furcal-involvement">
                  <span>Furcal Involvment</span>
                  <div style="flex-direction: row; margin-top: 4px;">
                    <mat-checkbox class="checkbox" style="flex: 1;  padding-right: 10px;" [checked]="currentDiagnosis.isFurcalInvolvementLVL1" (change)="onBooleanChange($event, 'isFurcalInvolvementLVL1')">1</mat-checkbox>
                    <mat-checkbox class="checkbox" style="flex: 1;  padding-right: 10px;" [checked]="currentDiagnosis.isFurcalInvolvementLVL2" (change)="onBooleanChange($event, 'isFurcalInvolvementLVL2')">2</mat-checkbox>
                    <mat-checkbox class="checkbox" style="flex: 1;  padding-right: 10px;" [checked]="currentDiagnosis.isFurcalInvolvementLVL3" (change)="onBooleanChange($event, 'isFurcalInvolvementLVL3')">3</mat-checkbox>
                  </div>
                </div>
            </div>
            <div class="column">
                <div class="header">Probable Etiology</div>
                <div *ngFor="let item of probableEtiology">
                  <mat-checkbox class="checkbox" style="flex: 1;" [checked]="currentDiagnosis[item.value]" (change)="onBooleanChange($event, item.value)">{{item.description}}</mat-checkbox>
                </div>
                <div class="header">Differential Diagnosis Pathology</div>
                <div *ngFor="let item of diffDiagnosis">
                  <mat-checkbox class="checkbox" style="flex: 1;" [checked]="currentDiagnosis[item.value]" (change)="onBooleanChange($event, item.value)">{{item.description}}</mat-checkbox>
                </div>
            </div>
            </div>
        </div>
        <div class="actions">
            <button class="tdo-button primary-accent" (click)="onPrint()">Print</button>
            <button class="tdo-button primary-accent" (click)="onSaveAsNote()">Save as Note</button>
        </div>
        </div>
    </div>
</div>
